import axios from "axios";
import Pusher, { Channel, ChannelAuthorizationCallback } from "pusher-js";
import consts from "../../shared/consts";
import { Region } from "shared/region";

// Define the expected response type from the Pusher auth endpoint
interface ChannelAuthorizationData {
  auth: string;
  channel_data?: string;
}

// Define the request data type
interface PusherAuthRequest {
  channel_name: string;
  socket_id: string;
}

const config = {
  [Region.US]: {
    key: process.env.PUSHER_APP_KEY,
    cluster: process.env.PUSHER_CLUSTER,
  },
  [Region.EU]: {
    key: process.env.PUSHER_APP_KEY_EU,
    cluster: process.env.PUSHER_CLUSTER_EU,
  },
};

export function createPusherInstance() {
  const authToken = sessionStorage.getItem(consts.CANVAS_AUTH_TOKEN);
  const region = (sessionStorage.getItem("region") ?? Region.US) as Region;
  const key = config[region]?.key;
  const cluster = config[region]?.cluster;
  if (!key || !cluster) {
    throw new Error("PUSHER_APP_KEY or PUSHER_CLUSTER not set");
  }
  return new Pusher(key, {
    cluster,
    authorizer: (channel: Channel, _options: any) => {
      return {
        authorize: (socketId: string, callback: ChannelAuthorizationCallback) => {
          const requestData: PusherAuthRequest = {
            channel_name: channel.name,
            socket_id: socketId,
          };

          axios
            .post<ChannelAuthorizationData>(
              `${process.env.HOST}${process.env.NEXT_BRANCH_PATH}/pusher/auth`,
              requestData,
              {
                headers: {
                  [consts.CANVAS_AUTH_TOKEN]: authToken || "",
                  "x-region": region || "",
                },
                withCredentials: true,
              }
            )
            .then((response) => {
              // The response.data is already typed as ChannelAuthorizationData
              callback(null, response.data);
            })
            .catch((error) => {
              callback(new Error(`Error authenticating with server: ${error}`), {
                auth: "",
              });
            });
        },
      };
    },
  });
}
